<script context="module" lang="ts">
  import type { ClientUserStore } from 'shared/src';
  import { serverOrClientUserStorePageLoadFunction } from '$lib/stores/getUserStore';
  // export const load = userStorePageLoadFunction;
  export const load = serverOrClientUserStorePageLoadFunction;
</script>

<script lang="ts">
  import { autorun } from 'mobx';
  import { onDestroy } from 'svelte';
  import { sortByFactory } from 'shared/src/utils/sortByFactory';
  import type { UserLessonOrCheckpointStore } from 'shared/src/user/userLessons/user.lessonOrCheckpoint.store';
  import LessonStartButton from '$lib/app/lessons/LessonStartButton.svelte';
  import LessonTitleLink from '$lib/app/lessons/LessonTitleLink.svelte';
  import LessonOrCheckpointInlineStatus from '$lib/app/lessons/LessonOrCheckpointInlineStatus.svelte';
  import Hr from '$lib/components/Hr.svelte';
  import { slide } from 'svelte/transition';
  import CountTo from '$lib/components/CountTo.svelte';

  export let clientUserStore: ClientUserStore;

  let areas: {
    title: string;
    enabled: boolean;
    isRequired: boolean;
    isOptional: boolean;
    progress: number;
    lessons: {
      title: string;
      id: string;
      isAvailable: boolean;
      type: 'lesson' | 'checkpoint';
      store: UserLessonOrCheckpointStore;
    }[];
  }[];
  const destroyer = autorun(() => {
    areas = clientUserStore.lessonProgress.areas
      .map((area) => {
        const title = area.title;
        const enabled = area.isVisible;
        const isRequired = area.isRequired;
        const isOptional = area.isOptional;
        const progress = area.progress;
        const lessons = area.lessons
          .filter((l) => l.isVisible)
          .map((lesson) => ({
            title: lesson.title,
            id: lesson.id,
            isAvailable: lesson.isAvailable,
            type: lesson.type,
            store: lesson,
          }));
        return {
          title,
          lessons,
          enabled,
          isRequired,
          isOptional,
          progress,
        };
      })
      .sort(sortByFactory('title'))
      .reverse();
  });
  onDestroy(destroyer);
</script>

{#each areas as area}
  <div class="lg:w-1/3">
    <div class="text-center">
      <h2 class="text-slate-600 text-3xl font-medium mb-2">{area.title}</h2>
      <div class="mb-6">
        {#if area.isRequired}
          <p class="text-center"><CountTo value={area.progress} duration={500} />% completed</p>
        {:else if area.isOptional}
          <p>Optional Area</p>
        {:else if !area.enabled}
          <p>Area disabled by instructor.</p>
        {/if}
      </div>
      <Hr class="border-gray-100 mb-6" />
    </div>
    <ul>
      {#each area.lessons as lesson}
        <li class="mb-8" transition:slide|local>
          <div class="flex">
            <div class="flex-grow">
              <LessonTitleLink
                id={lesson.id}
                isAvailable={lesson.isAvailable}
                title={lesson.title}
                type={lesson.type}
              />
              <LessonOrCheckpointInlineStatus lessonOrCheckpointStore={lesson.store} />
            </div>
            <div>
              <LessonStartButton lessonStore={lesson.store} />
            </div>
          </div>
        </li>
      {/each}
    </ul>
  </div>
{/each}
